import React from 'react';

interface Player {
  id: string;
  name: string;
  score: number;
  avatar?: string;
}

interface MiniLeaderboardProps {
  players: Player[];
  myPlayerId?: string;
  answeredPlayerIds?: Set<string>;
  maxPlayers?: number;
  showScores?: boolean;
}

const MiniLeaderboard: React.FC<MiniLeaderboardProps> = ({
  players,
  myPlayerId,
  answeredPlayerIds = new Set(),
  maxPlayers = 8,
  showScores = true,
}) => {
  const sortedPlayers = [...players].sort((a, b) => b.score - a.score).slice(0, maxPlayers);

  return (
    <div className="mini-leaderboard" data-testid="mini-leaderboard">
      <div className="mini-leaderboard-grid">
        {sortedPlayers.map((player, index) => {
          const isMe = player.id === myPlayerId;
          const hasAnswered = answeredPlayerIds.has(player.id);
          const isAvatarImage = player.avatar && (
            player.avatar.startsWith('/') ||
            player.avatar.startsWith('data:') ||
            player.avatar.includes('.svg') ||
            player.avatar.includes('media')
          );

          return (
            <div
              key={player.id}
              className={`mini-leaderboard-row${isMe ? ' mini-leaderboard-row--me' : ''}${index === 0 ? ' mini-leaderboard-row--first' : ''}`}
            >
              <div className="mini-leaderboard-row__left">
                <span className="mini-leaderboard-row__rank" aria-hidden>
                  {index === 0 && '🥇'}
                  {index === 1 && '🥈'}
                  {index === 2 && '🥉'}
                  {index > 2 && (
                    isAvatarImage
                      ? <img src={player.avatar} alt="" className="mini-leaderboard-row__avatar" />
                      : <span>{player.avatar || '👤'}</span>
                  )}
                </span>
                <span className="mini-leaderboard-row__name">{player.name}</span>
              </div>
              <div className="mini-leaderboard-row__right">
                {showScores && (
                  <span className="mini-leaderboard-row__score">{player.score}</span>
                )}
                {hasAnswered && (
                  <span className="mini-leaderboard-row__answered" aria-hidden>✓</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MiniLeaderboard;
